import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./intro.module.css";
export const EvIntro = ({ introText  })=>/*#__PURE__*/ _jsx("section", {
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.evIntroText,
            children: introText
        })
    });
